"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconDiscount = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconDiscount = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M17 8.522 15.455 7 7 15.479 8.545 17 17 8.522Zm-6.459-.42a1.57 1.57 0 0 0-1.153-.48c-.45 0-.834.16-1.153.48-.32.32-.48.706-.48 1.156 0 .45.16.836.48 1.156.32.32.704.481 1.153.481.45 0 .834-.16 1.153-.48.32-.32.48-.706.48-1.157 0-.45-.16-.836-.48-1.156Zm5.442 5.456a1.57 1.57 0 0 0-1.153-.48c-.45 0-.834.16-1.153.48-.32.32-.48.706-.48 1.157 0 .45.16.835.48 1.156.319.32.703.48 1.153.48.449 0 .833-.16 1.153-.48.32-.32.48-.706.48-1.156 0-.45-.16-.836-.48-1.157Z"
}), /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.571 20.153 12 23.5l3.429-3.347h4.724v-4.724L23.5 12l-3.347-3.429V3.847h-4.724L12 .5 8.571 3.847H3.847v4.724L.5 12l3.347 3.429v4.724h4.724Zm5.942-2.12L12 20.545l-2.513-2.514h-3.52v-3.519L3.455 12l2.514-2.513v-3.52h3.519L12 3.455l2.513 2.514h3.52v3.519L20.545 12l-2.514 2.513v3.52h-3.519Z"
}));
exports.IconDiscount = IconDiscount;
//# sourceMappingURL=IconDiscount.js.map